import {SideNavigationMenuItemContainerProps} from '../types/SideNavigationTypes';
import {SideNavigationMenuItem} from '../side-navigation-menu-item/SideNavigationMenuItem';
import styles from './SideNavigationPrimary.module.scss';
import {useSideNavigationCollapseContext} from '../side-navigation-contexts/SideNavigationCollapseContext';
import classNames from 'classnames';

export const SideNavigationPrimary = ({menuItems}: SideNavigationMenuItemContainerProps) => {
    
    const {isCollapsed} = useSideNavigationCollapseContext();
    
    const sideSideNavigationPrimaryContainerStyling = classNames(
        styles.sideNavigationPrimaryContainer,
        {[styles.collapsed]: isCollapsed},
    );
    
    return (
        <div className={sideSideNavigationPrimaryContainerStyling}>
            {
                menuItems.map(
                    (menuItem, index) => {
                        return <SideNavigationMenuItem {...menuItem} key={index}/>
                    }
                )
            }
        </div>
    );
}